import React, { useEffect, useState } from "react";
import { PageHero } from "../components/Section";
import { useApp } from "../context/AppContext";
import { useReveal } from "../hooks/useReveal";
import { producers as mockProducers, IMAGES } from "../data/mock";
import { getProducers } from "../services/api";
import Seo from "../components/Seo";
import { MapPin } from "lucide-react";

const Producers = () => {
  const { t, lang } = useApp();
  const [producers, setProducers] = useState(mockProducers);
  useReveal([producers]);
  useEffect(() => { getProducers().then((d) => { if (Array.isArray(d) && d.length) setProducers(d); }).catch(() => {}); }, []);
  return (
    <div className="pt-20 bg-cream min-h-screen">
      <Seo title={t("producers.title")} description={t("producers.sub")} path="/producers" lang={lang} />
      <PageHero title={t("producers.title")} subtitle={t("producers.sub")} image={IMAGES.winemaker} />
      <div className="max-w-6xl mx-auto px-6 pt-14 -mb-2">
        <p className="max-w-3xl text-lg text-ink/70 leading-relaxed">{t("producers.intro")}</p>
      </div>
      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-8">
        {producers.map((p) => (
          <div key={p.id} className="reveal group flex flex-col sm:flex-row bg-white rounded-2xl overflow-hidden border border-border hover:shadow-xl transition-all duration-300">
            <div className="sm:w-44 h-52 sm:h-auto overflow-hidden shrink-0">
              <img src={p.img} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-6 flex flex-col justify-center">
              <h3 className="font-serif text-2xl text-wine">{p.name}</h3>
              <p className="flex items-center gap-1.5 text-sm text-gold-dark mt-1"><MapPin className="w-4 h-4" /> {p.region}</p>
              <p className="mt-3 text-ink/65 leading-relaxed">{p.bio[lang]}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Producers;
